import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { ColorScheme } from "shared/context/color-scheme/ColorScheme"
import { useColorScheme } from "shared/lib/color-scheme/useColorScheme"
import { useEvent } from "shared/lib/useEvent"
import { SelectOption } from "shared/types/Select"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { Select } from "shared/ui/input/select/select/Select"

export const ColorSchemeSelect = React.memo(() => {
  const { preferredColorScheme, setPreference } = useColorScheme()
  const { t } = useTranslation()

  const handleChange = useEvent((nextColorScheme: ColorScheme | null) => {
    setPreference(nextColorScheme ?? ColorScheme.SYSTEM)
  })

  const colorSchemeOptions = useMemo<SelectOption<ColorScheme>[]>(() => {
    return [
      { label: t("ColorScheme.Dark"), value: ColorScheme.DARK },
      { label: t("ColorScheme.Light"), value: ColorScheme.LIGHT },
      { label: t("ColorScheme.System"), value: ColorScheme.SYSTEM }
    ]
  }, [t])

  return (
    <Select.Root
      inputID="color-scheme-select"
      label={t("ColorScheme.ColorScheme")}
      className="color-scheme-select"
    >
      <Select.Label icon={IconName.VIEWMODE} />
      <Select.Input
        value={preferredColorScheme}
        onChange={handleChange}
        options={colorSchemeOptions}
      />
    </Select.Root>
  )
})
